import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getTradeShowFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.tradeshow}`);
    return response;
}

export const getTradeShowByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.tradeshow}`);
    return response;
}

export const postTradeShowFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.tradeshow}`, reqBody);
    return response;
}

export const patchTradeShowFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.tradeshow}`, reqBody);
    return response;
}

export const deleteTradeShowFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.tradeshow}`, { data: reqBody });
    return response;
}
